/**
 * Contract Alert Workflow Machine Config
 *
 * Spec: Documentation/Specification/04_Processes/application-specific/hr/onboarding/ContractAlertProcess.md
 * States: draft → active → alertTriggered → acknowledged → renewed/expired
 */
export const contractAlertConfig = {
    id: 'contract-alert',
    initial: 'draft',
    states: {
        draft: {
            on: { ACTIVATE: 'active' },
        },
        active: {
            on: { TRIGGER_ALERT: { target: 'alertTriggered', guard: 'alertWindowReached' } },
        },
        alertTriggered: {
            entry: { type: 'sendAlertNotification' },
            on: {
                ACKNOWLEDGE: { target: 'acknowledged', guard: 'managerResponded' },
                ESCALATE: 'acknowledged',
            },
        },
        acknowledged: {
            on: {
                RENEW: 'renewed',
                EXPIRE: 'expired',
            },
        },
        renewed: {
            entry: { type: 'processRenewal' },
            type: 'final',
        },
        expired: {
            entry: { type: 'processExpiry' },
            type: 'final',
        },
    },
};
//# sourceMappingURL=contract-alert.js.map